import React from 'react'
import AppBackBtn from '../components/ui/AppBackBtn'
import AppWrapper from '../components/ui/AppWrapper/AppWrapper'

const ContactView: React.FC = () => {
  return (
    <>
      <AppBackBtn to="/home" />
      <AppWrapper className="bg-appLightGray h-[80%] gap-y-4">
        <p className="text-black font-semibold text-[15px]">
          Автономная некоммерческая организация "Платформа электоральных технологий"
        </p>
        <ul role="list" className="divide-y divide-gray-200">
          <li className="py-4 flex items-center">
            <i className="fas fa-file-alt fa-2x text-primary"></i>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-900">ИНН</p>
              <p className="text-sm text-gray-500">1655378684</p>
            </div>
          </li>
          <li className="py-4 flex items-center">
            <i className="fas fa-phone-alt fa-2x text-primary"></i>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-900">Контактный телефон</p>
              <p className="text-sm text-gray-500">+78435983150</p>
            </div>
          </li>
          <li className="py-4 flex items-center">
            <i className="fas fa-envelope fa-2x text-primary"></i>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-900">Электронная почта</p>
              <p className="text-sm text-gray-500">electoral.platform@gmail.com</p>
            </div>
          </li>
        </ul>
        <p className="text-[13px] font-medium">
          420111, Республика Татарстан, город Казань, Театральная улица, дом 1/29
        </p>
      </AppWrapper>
    </>
  )
}

export default ContactView
